import * as React from 'react';
import { Route } from 'react-router-dom';
import { TooltipCont } from '../../infrastructure/tooltips';

export interface IStepperProps {
  currentStep: number;
  onNextStep(): void;
  onPrevStep(): void;
  onSkip(): void;
  onSave(): void;
  documentName: string;
  validation?: any;
}
export interface IStepperStates {
  children: any[];
}

export default class Stepper extends React.Component<IStepperProps, IStepperStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      children: React.Children.toArray(this.props.children),
    };
  }
  onPrevStep = (history: any) => {
    if (this.props.currentStep > 0) {
      this.props.onPrevStep();
    } else {
      window.history.back();
    }
  }

  onNextStep = (history: any) => {
    const steps = (this.state.children || []) as any[];
    if (this.props.currentStep < steps.length - 1) {
      this.props.onNextStep();
    } else {
      if (this.props.validation && !this.props.validation.pagesCountInput.status) {
        return;
      }
      this.props.onSave();
      history.push('/Editor');
    }

  }

  onSkip = (history: any) => {
    const steps = (this.state.children || []) as any[];
    this.props.onSkip();
    if (this.props.currentStep >= steps.length - 1) {
      this.props.onSave();
      history.push('/Editor');
    }
  }



  render() {
    const steps = (this.state.children || []) as any[];
    const currentStep = this.props.currentStep;
    return (
      <div className="stepContainer">
        <div className="stepContainerMain">
          <div className="stepTopBar">{`${this.props.documentName} - Project Setup`}</div>
          <div className="stepInfoBar">
            <Route
              render={({ history }) => {
                return (
                  <button
                    className="stepBarPreviousBtn"
                    title={TooltipCont.PREVIOUS}
                    onClick={() => this.onPrevStep(history)}
                  >
                  </button>
                );
              }}
            />
            <div className="stepInfoBarText">Step {currentStep + 1} of {steps.length}</div>
            <Route
              render={({ history }) => {
                return (
                  <button className="stepBarNextBtn" onClick={() => this.onNextStep(history)} title={TooltipCont.NEXT}>
                  </button>
                );
              }}
            />
          </div>
          <div>
            {steps[currentStep]}
          </div>
          <div className="stepFooter">
            <Route
              render={({ history }) => {
                return (
                  <button
                    className="previousBtn"
                    title={TooltipCont.PREVIOUS}
                    onClick={() => this.onPrevStep(history)}
                  >
                    <i className="fa fa-arrow-alt-circle-left"
                      aria-hidden="true"></i>
                    <span>Previous</span>
                  </button>
                );
              }}
            />
            <Route
              render={({ history }) => {
                return (
                  <button
                    className="nextBtn"
                    onClick={() => this.onNextStep(history)}
                    title={((this.state.children || []) as any[]).length - 1 === this.props.currentStep ? TooltipCont.FINISH : TooltipCont.NEXT}
                  >
                    <i className={'fa fa-arrow-alt-circle-right' + (this.props.currentStep === steps.length - 1 ? ' hideNextIcon' : '')}
                      aria-hidden="true"></i>
                    <i className={'checked fa fa-flag-checkered' +
                      (((this.state.children || []) as any[]).length - 1 !== this.props.currentStep
                        ? ' hideFinishIcon' : '')}
                      aria-hidden="true"></i>
                    <span>
                      {((this.state.children || []) as any[]).length - 1 === this.props.currentStep ? 'Finish' : 'Next'}
                    </span>
                  </button>
                );
              }}
            />
            <Route
              render={({ history }) => {
                return (
                  <button className="skipBtn" onClick={() => this.onSkip(history)} title={TooltipCont.SKIP}>
                    Skip
                </button>
                );
              }}
            />
          </div>
        </div >
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Steps/Stepper.tsx